import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const API_BASE =
  process.env.REACT_APP_UI_MODE === "development"
    ? "http://localhost:8080/api/v1/"
    : "https://gps-x.com/api/v1/";

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE,
    prepareHeaders: (headers, { _getState }) => {
      return headers;
    },
  }),
  tagTypes: [],
  endpoints: (builder) => ({
    uploadFile: builder.mutation({
      query: (data) => ({
        url: `tracks/convert`,
        method: "POST",
        body: data,
        formData: true,
        responseHandler: (response) => response.text(),
      }),
    }),
    startCsvConversion: builder.mutation({
      query: (data) => ({
        url: `tracks/convert-csv`,
        method: "POST",
        body: data,
        formData: true,
      }),
    }),
    getCsvConversionJob: builder.query({
      query: (jobId) => `tracks/convert-csv/jobs/${jobId}`,
    }),
    convertUrl: builder.query({
      query: (url) => ({
        url: `tracks/convert?file=${encodeURIComponent(url)}`,
        method: "GET",
        responseHandler: (response) => response.text(),
      }),
    }),
    lookupTide: builder.query({
      query: ({ lat, lon, time }) =>
        `tides?lat=${lat}&lon=${lon}&time=${encodeURIComponent(time)}`,
    }),
  }),
});

export const downloadCsvConversionJob = async (jobId) => {
  const response = await fetch(
    `${API_BASE}tracks/convert-csv/jobs/${jobId}/download`
  );
  if (!response.ok) {
    throw new Error(`Download failed (${response.status})`);
  }
  const blob = await response.blob();
  const disposition = response.headers.get("Content-Disposition") || "";
  const contentType = response.headers.get("Content-Type") || "";
  const summaryHeader = response.headers.get("X-Csv-Summary");
  let summary;
  if (summaryHeader) {
    try {
      summary = JSON.parse(summaryHeader);
    } catch (_error) {
      summary = undefined;
    }
  }
  return { blob, disposition, contentType, summary };
};

export const {
  useUploadFileMutation,
  useStartCsvConversionMutation,
  useGetCsvConversionJobQuery,
  useConvertUrlQuery,
  useLazyLookupTideQuery,
} = api;
